export default class BiService {
    private biServerUrl: string;
    private isExternal: boolean;
    private url: string;
    private data: Object;
    private options: Object;

    constructor(options) {
        this.biServerUrl = options.biServerUrl;
        this.isExternal = options.isExternal;
    }

    GET<T>(url: string, data: Object, options?: any) {
        var promise = this.executeAjax<T>("GET", url, data, options);
        return promise;
    }

    private executeAjax<T>(callType: string, url: string, data: Object, options?: any) {
        this.url = this.formatUrl(this.biServerUrl + url);
        this.data = data;
        this.options = options;

        var dataType = 'json_with_dates';
        var isAsync = navigator.appCodeName == 'Mozilla' ? false : true;

        if (typeof options !== 'undefined') {
            if (typeof options.dataType !== 'undefined') {
                dataType = options.dataType;
            }
        }

        Promise.onPossiblyUnhandledRejection(reason => {
            // Note - We do nothing here. This is to keep BlueBird from spamming the console when bad requests occur
        });

        var promise = new Promise<T>((resolve, reject, onCancel) => {
            var ajaxOptions = {
                url: this.url,
                async: isAsync,
                data: null,
                xhrFields: {
                    withCredentials: true
                },
                contentType: null,
                error: err => {
                    reject(err);
                },
                type: callType,
                dataType: dataType
            };

            if (callType == 'GET') {
                ajaxOptions.data = this.data;
            } else {
                ajaxOptions.data = JSON.stringify(this.data);
                ajaxOptions.contentType = 'application/json';
            }

            var xhr = $.ajax(ajaxOptions);

            onCancel(() => {
                xhr.abort();
            });

        });

        promise.then(val => {
            return val;
        }, err => {
            var error = err.err ? err.err : err;
            return error;
        });

        return promise;
    }

    private formatUrl(url) {
        if (!this.isExternal) {
            url = url.replace("//", "/");
        }

        return url;
    }

    logout() {
        this.GET("/api/auth/logout", {}, { dataType: "json" });
    }
}